export default "__VITE_ASSET__C_eBc4rn__"